import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type {
  DecisioningStudioLaunchValidationError,
  GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult,
} from "./types";

/**
 * Named so the POST launch endpoint can reuse it: `LAUNCH_INCOMPLETE` rejections carry this same
 * error shape under `meta.errors`, and both paths should accept exactly the same payloads.
 */
export const isDecisioningStudioLaunchValidationError = objectOf<DecisioningStudioLaunchValidationError>({
  title: string,
  copy: string,
  type: string,
  step_id: string,
  severity: maybe(string, true),
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult>({
    can_launch: boolean,
    errors: arrayOf(isDecisioningStudioLaunchValidationError),
  });
